<template>
  <div class="registration__box">
    <template v-if="!showSuccess">
      <h1 class="header--mobile">
        <span class="header__text">{{ trans.mobileHeader2 }} </span>
      </h1>
      <h1 class="header--desktop">
        <span
          v-for="(header, index) in trans.desktopHeader"
          :key="index"
          :class="` ${trans.desktopHeaderHighlight.includes(index) ? 'highlight' : 'header__text'}`"
          >{{ header }}
        </span>
      </h1>
      <div class="step">
        <div class="step__icon-wrapper"><img :src="`${IMAGE_ROOT}/pencil.svg`" class="step__icon" /></div>
        <p class="step__text">{{ trans.step1 }}</p>
      </div>
      <div class="step">
        <div class="step__icon-wrapper"><img :src="`${IMAGE_ROOT}/prize.svg`" class="step__icon" /></div>
        <p class="step__text">{{ trans.step2 }}</p>
      </div>
      <div class="step">
        <div class="step__icon-wrapper"><img :src="`${IMAGE_ROOT}/survey.svg`" class="step__icon" /></div>
        <p class="step__text">{{ trans.step3 }}</p>
      </div>
      <div v-if="isProjectMeteor" class="only-now">
        <span class="highlight">Jetzt für kurze Zeit:</span> Gratis VIQ® Persönlichkeitstest für neue
        Mitglieder innerhalb von 24h ab Ihrer Registrierung!
      </div>
    </template>

    <form id="register_form" name="register_form" class="registration__form" v-if="!showSuccess">
      <label class="label">
        <input
          class="textinput"
          type="text"
          id="firstname"
          :placeholder="trans.firstname"
          v-model="firstname"
        />
        <span class="error-message">{{ this.validationMessages.firstname }}</span>
      </label>
      <label class="label">
        <input class="textinput" type="text" id="surname" :placeholder="trans.lastname" v-model="lastname" />
        <span class="error-message">{{ this.validationMessages.surname }}</span>
      </label>
      <label class="label">
        <select class="selectinput" id="country" placeholder="Land" disabled>
          <option :value="trans.country.code">{{ trans.country.label }}</option>
        </select>
        <span class="error-message">{{ this.validationMessages.country }}</span>
      </label>
      <label class="label">
        <input class="textinput" type="email" id="email" :placeholder="trans.email" v-model="email" />
        <span class="error-message">{{ this.validationMessages.email }}</span>
      </label>
      <label class="label">
        <input
          class="textinput"
          type="password"
          id="password"
          :placeholder="trans.password"
          v-model="password"
        />
        <span class="error-message">{{ this.validationMessages.password }}</span>
      </label>
      <div class="checkbox-container">
        <label class="checkbox-label">
          {{ trans.terms1 }}
          <a
            :href="
              `https://talkonlinepanel.com/${trans.countryCode}/TC-20180521?source=${source}${sourceuidQuery}`
            "
            target="_blank"
            class="link"
            >{{ trans.terms2 }}</a
          >
          {{ trans.terms3 }}

          <input type="checkbox" id="agb" v-model="agb" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="checkbox-container">
        <label class="checkbox-label">
          {{ trans.privacy1 }}
          <a
            :href="
              `https://talkonlinepanel.com/${trans.countryCode}/${
                trans.privacyDynamicPart
              }?source=${source}${sourceuidQuery}`
            "
            target="_blank"
            class="link"
            >{{ trans.privacy2 }}</a
          >
          {{ trans.privacy3 }}
          <input type="checkbox" id="gdpr" v-model="gdpr" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="checkbox-container">
        <label class="checkbox-label">
          {{ trans.cookie1 }}
          <a
            :href="
              `https://talkonlinepanel.com/${trans.countryCode}/CP-20180521?source=${source}${sourceuidQuery}`
            "
            target="_blank"
            class="link"
            >{{ trans.cookie2 }}</a
          >
          {{ trans.cookie3 }}
          <input type="checkbox" id="cookie" v-model="cookie" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div v-html="this.validationMessages.terms_privacy_cookies_accepted" class="error-message label"></div>

      <button id="submit" class="submit" :class="{ submitting: submitting }" type="button" @click="submit">
        {{ trans.submit }}{{ submitting ? '...' : '' }}
      </button>

      <div class="description__wrapper">
        <p class="description__header">{{ trans.whatis }}</p>
        <p class="description">{{ trans.description }}</p>
        <img class="red-logo" :src="`${IMAGE_ROOT}/logo-talk-panel_red.svg`" alt="" />
      </div>
      <p v-if="false" class="clients">{{ trans.partners }}</p>
    </form>
    <div v-else id="success" class="success">
      <p v-for="successMsg in trans.success" :key="successMsg">{{ successMsg }}</p>
    </div>
  </div>
</template>

<script>
import { IMAGE_ROOT } from '~/utils/constants';

export default {
  props: {
    trans: {}
  },
  data() {
    return {
      IMAGE_ROOT,
      firstname: null,
      lastname: null,
      email: null,
      password: null,
      agb: false,
      gdpr: false,
      cookie: false,
      showSuccess: false,
      submitting: false,
      isValid: false,
      errorMessages: {}
    };
  },
  computed: {
    source() {
      const source = this.getQueryParams().filter(pair => pair[0] === 'source');

      if (!!source && source.length > 0) return source[0][1];
      return 'no_source_provided';
    },
    source_uid() {
      const source_uid = this.getQueryParams().filter(pair => pair[0] === 'sourceuid');

      if (!!source_uid && source_uid.length > 0) return source_uid[0][1];
      return null;
    },
    sourceuidQuery() {
      return !this.source_uid ? '' : `&sourceuid=${this.source_uid}`;
    },
    validationMessages() {
      const messages = {};
      for (let key in this.errorMessages) {
        messages[key] = this.errorMessages[key].join(' ');
      }
      return messages;
    },
    isProjectMeteor() {
      const query = this.$route.query;
      return !!query.project && query.project === 'meteor';
    }
  },
  methods: {
    getQueryParams() {
      return location.search
        .replace('?', '')
        .split('&')
        .map(query => query.split('='));
    },
    submit() {
      const terms = [];

      if (this.agb) {
        terms.push('terms_accepted_20180521');
      }
      if (this.gdpr) {
        terms.push('privacy_accepted_20180521');
      }
      if (this.cookie) {
        terms.push('cookie_accepted_20180521');
      }
      this.submitting = true;
      const meta = {
        user_agent: navigator.userAgent,
        source: this.source
      };
      if (this.source_uid) {
        meta.source_uid = this.source_uid;
      }

      try {
        grecaptcha.ready(() => {
          grecaptcha.execute('6LckGZ0UAAAAAMxVtakR-uqG5kqLTdNxgXf3cZvw', { action: 'submit' }).then(token => {
            meta.rc = token;

            fetch('https://ag7s1bmjo0.execute-api.eu-west-1.amazonaws.com/production/talk-register-to-api', {
              method: 'POST',
              body: JSON.stringify({
                data: {
                  answers: {
                    firstname: this.firstname,
                    surname: this.lastname,
                    country: this.trans.country.code,
                    email: this.email,
                    password: this.password,
                    terms_privacy_cookies_accepted: terms
                  },
                  meta
                },
                panel: this.trans.panelCode
              })
            })
              .then(res => {
                if (res.status === 201) {
                  this.showSuccess = true;
                  this.submitting = false;
                }
                return res.json();
              })
              .then(data => {
                if (!data.errors) return;
                let errors = [];
                this.submitting = false;

                this.errorMessages = data.errors;
              })
              .catch(e => {
                this.submitting = false;

                this.errorMessages = { ...e.errors };
              });
          });
        });
      } catch (e) {
        console.error('could not register');
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import '../assets/registrationBox.less';
.submitting {
  pointer-events: none;
  opacity: 0.3;
}
</style>
